import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Select from '../../forms/Select/Select'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { kvkTypes } from '../../../utilities/constants'
import { capitalize } from '../../../utilities/helpers'
import useConfirmation from '../../../hooks/ConfimationHook'

const WriteKvk = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const kvkTypeOptions = kvkTypes.map((type) => ({ value: type, label: type.toUpperCase() }))
    const formName = 'writeKvk'
    const { kvk, stellarSeason } = modal.$state.data
    const { markOrExecute, isMarked } = useConfirmation()

    const writeKvkRef = useRef()
    writeKvkRef.current = () => {
        const formValues = form.$state.value

        const newKvk = { ...formValues, stellarSeason }

        const saveKvk = kvk ? koalition.put(`kvks/${kvk._id}`, newKvk) : koalition.post('kvks', newKvk)
        saveKvk.then((response) => {
            modal.close()
            toaster.success('Kvk created successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const deleteKvk = () => {
        koalition.delete(`kvks/${kvk?._id}`).then((response) => {
            toaster.success('Kvk deleted successfully')
            modal.close()
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => writeKvkRef.current(), controls: {
        type: { validators: [Validators.required], value: kvk?.type },
    } })

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <div className="row">
            <div className="col-12 mb-3">
                <Select options={kvkTypeOptions} control={form.$state.controls.type} label="Kvk" />
            </div>

            {kvk && (
                <div className="col-12 my-4">
                    <button type="button" className={`danger outline ${isMarked(kvk._id) ? 'marked' : ''} medium`} onClick={() => markOrExecute(kvk._id, deleteKvk)}>
                        <span>Delete Kvk</span>
                    </button>
                </div>
            )}
        </div>
    )
}

export default WriteKvk